import { render, staticRenderFns } from "./UniswapMessages.vue?vue&type=template&id=d57de6b4&scoped=true&"
import script from "./UniswapMessages.vue?vue&type=script&lang=js&"
export * from "./UniswapMessages.vue?vue&type=script&lang=js&"
import style0 from "./UniswapMessages.vue?vue&type=style&index=0&id=d57de6b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d57de6b4",
  null
  
)

export default component.exports